(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["raambord-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rb-finder')) {
  customElements.define('rb-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.catalog = JSON.parse(this.querySelector('[data-rb-catalog]').textContent).collections;
      this.occasion = this.querySelector('[data-rb-occasion]');
      this.design = this.querySelector('[data-rb-design]');
      this.occasion.addEventListener('change', () => this.showSelection());
      this.design.addEventListener('change', () => this.showSelection());
      this.input = this.querySelector('input[type="search"]');
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.revision = (this.revision || 0) + 1;
        if (this.input.value.trim().length < 2) { this.querySelector('.rb-finder__suggestions').hidden = true; return; }
        const revision = this.revision;
        this.timer = setTimeout(() => this.search(this.input.value.trim(), revision), 300);
      });
      this.input.addEventListener('keydown', e => { if (e.key === 'Escape') this.querySelector('.rb-finder__suggestions').hidden = true; });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
    card(product, compact = false) {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = product.url;
      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.width = compact ? 64 : 240;
        img.height = compact ? 64 : 240;
        img.loading = 'lazy';
        link.append(img);
      }
      const text = document.createElement('span');
      text.textContent = product.title;
      link.append(text);
      if (product.price) { const price = document.createElement('strong'); price.textContent = product.price; link.append(price); }
      item.append(link);
      return item;
    }
    showSelection() {
      const group = this.catalog.find(c => c.id === this.occasion.value) || (this.design.value !== 'all' ? {url: this.dataset.allSearch.replace(/\/search$/, '/collections/all'), products: [...new Map(this.catalog.flatMap(c => c.products).map(p => [p.url, p])).values()]} : null);
      const wrapper = this.querySelector('.rb-finder__matches');
      wrapper.hidden = !group;
      if (!group) return;
      const products = group.products.filter(p => p.available && (this.design.value === 'all' || p.personal === (this.design.value === 'personal'))).slice(0, 4);
      this.querySelector('.rb-finder__grid').replaceChildren(...products.map(p => this.card(p)));
      wrapper.querySelector('[role="status"]').textContent = products.length ? this.dataset.count : this.dataset.empty;
      wrapper.querySelector('.rb-finder__collection').href = group.url;
    }
    async search(query, revision) {
      const panel = this.querySelector('.rb-finder__suggestions');
      const all = panel.querySelector('.rb-finder__search-all');
      const link = new URL(this.dataset.allSearch, location.origin);
      link.searchParams.set('q', query);
      link.searchParams.set('type', 'product');
      all.href = link.pathname + link.search;
      this.abort = new AbortController();
      const url = new URL(this.dataset.searchUrl + '.json', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      try {
        const response = await fetch(url, {signal:this.abort.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const result = await response.json();
        if (revision !== this.revision) return;
        const products = result.resources.results.products;
        panel.querySelector('.rb-finder__list').replaceChildren(...products.map(p => this.card({title:p.title,url:p.url,image:typeof p.image === 'string' ? p.image : p.featured_image?.url}, true)));
        panel.querySelector('[role="status"]').textContent = products.length ? this.dataset.searchLabel : this.dataset.empty;
        panel.hidden = false;
      } catch (error) {
        if (error.name === 'AbortError' || revision !== this.revision) return;
        panel.querySelector('.rb-finder__list').replaceChildren();
        panel.querySelector('[role="status"]').textContent = this.dataset.error;
        panel.hidden = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raambord-mobile-order"]) return;
  try {
    
if (!customElements.get('rb-mobile-order')) {
  customElements.define('rb-mobile-order', class extends HTMLElement {
    connectedCallback() {
      this.options = document.querySelector('.pr_meta');
      this.submit = this.options?.querySelector('button[name="add"]');
      if (!this.options || !this.submit) return;
      this.querySelector('button').addEventListener('click', () => {
        this.options.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        const focus = this.options.querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]),select,button[name="add"]');
        if (focus) focus.focus({preventScroll:true});
      });
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, {threshold:0});
      this.observer.observe(this.submit);
      const price = this.options.querySelector('[id^="ProductPrice-"]');
      if (price) {
        this.priceObserver = new MutationObserver(() => {this.querySelector('[data-rb-price]').textContent = price.textContent;});
        this.priceObserver.observe(price,{childList:true,subtree:true,characterData:true});
      }
    }
    disconnectedCallback() {this.observer?.disconnect();this.priceObserver?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
